export default __webpack_public_path__ + "static/media/top102.3863495a.jpg";